// Maps columnId to specific edit modal components
// This enables certain columns to use specialized edit modals
// If columnId is not specified, the default ColumnEditModal is used
const columnEditModalMapping = {
  'site-id': () => import('../components/modals/SiteIdColumnModal'),
  'parameter-name': () => import('../components/modals/AnalyteNameColumnModal'),
  'mediatype': () => import('../components/modals/MediatypeColumnModal'),
  'depth-datum-start': () => import('../components/modals/DepthStartColumnModal'),
  'depth-datum-end': () => import('../components/modals/DepthEndColumnModal'),
  'sample-datetime-year': () => import('../components/modals/SampleDateTimeYearColumnModal'),
  'sample-datetime-month': () => import('../components/modals/SampleDateTimeMonthColumnModal'),
  'sample-datetime-day': () => import('../components/modals/SampleDateTimeDayColumnModal'),
  'vmv-code': () => import('../components/modals/VMVCodeColumnModal'),
  'reportable-detection-limit': () => import('../components/modals/ReportableDetectionLimitColumnModal'),
  'result': () => import('../components/modals/ResultColumnModal'),
  'depth-datum-depth-or-height' : () => import('../components/modals/DepthDatumTypeModal'),
}

export default columnEditModalMapping
